<template>
    <div class="content-modal">
      <div class="cover" @click="modalClose()"></div>
      <div class="embed-wrapper">
        <span class="close-wrap">
          <a class="btn" @click="modalClose()">
            <div class="line"></div>
            <div class="line"></div>
          </a>
        </span>
        <div class="modal-content">
          <h3><span class="num">8</span>月<span class="num">4</span>日 栄養の日</h3>
          <div class="logo-wrap">
              <LogoYobo class="logo" />
              <TextYobo class="word" />
              <div class="word02">Of the year</div>
          </div>
          <p class="info">「予防めし」オブ・ザ・イヤー 決定！</p>
          <btnRounded to="./yobomeshi" class="yellow small">受賞レシピを見る</btnRounded>
        </div>
      </div>
    </div>
</template>

<script>
import LogoYobo from '@/assets/logo-yobo.svg?inline'
import TextYobo from '@/assets/txt-yobo.svg?inline'
import btnRounded from '@/components/parts/btn-rounded.vue'
export default {
    components: {
      LogoYobo,
      TextYobo,
      btnRounded
    },
    props:{
        vidSrc: String
    },
    data(){
        return{
            option: {
                autoplay: 1,
            }
        }
    },
    methods:{
        modalClose() {
            this.$emit('clicked');
        }
    }
}
</script>

<style lang="scss">
.content-modal{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  z-index: 100;
  .cover{
    background: rgba($color: #000000, $alpha: .6);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .close-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 34px;
    height: 50px;
      a.btn{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 34px;
        height: 34px;
          .line{
            position: absolute;
            background: $white;
            width: 100%;
            height: 2px;
            transform: rotate(45deg);
            transform-origin: center;
            @media #{$IE}{
                left: 0;
            }
            &:last-child{
              transform: rotate(-45deg);
            }
          }
      }
  }
.embed-wrapper{
    position: relative;
    height: 634px;
    overflow: hidden;
    max-width: 100%;
    width: 628px;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    justify-content: center;
    @media #{$maxM}{
      width: auto;
    }
  }
}
.modal-content {
  width: 628px;
  text-align: center;
  padding: 40px 0;
  background-image: url('~@/assets/texture.jpg');
  background-size: contain;
  background-repeat: repeat;
  @media #{$maxM}{
    width: auto;
    padding: 40px 15px;
  }
  h3 {
    font-size: 38px;
    display: inline-block;
    position: relative;
    @media #{$maxM}{
      font-size: 28px;
    }
    .num {
      font-family: $rosewood;
      font-size: 65px;
      margin-right: -5px;
      color: $red;
      @media #{$maxM}{
        font-size: 48px;
        margin-right: -2px;
      }
    }
    &:after {
      content: '';
      width: 95.5%;
      height: 3px;
      background: black;
      position: absolute;
      bottom: -2px;
      left: 49.5%;
      transform: translate(-50%, 0);;
    }
  }
  .logo-wrap {
    width: 264px;
    height: auto;
    margin: 0 auto;
    @media #{$maxM}{
      width: 240px;
    }
    svg {
      width: 167px;
      margin: 0 auto;
      @media #{$maxM}{
        width: 152px;
      }
    }
    .logo {
      margin-top: 45px;
      @media #{$maxM}{
        margin-top: 38px;
      }
    }
    .word {
      margin-top: 10px;
      @media #{$maxM}{
        margin-top: 8px;
      }
    }
    .word02 {
      font-family: $rosewood;
      font-size: 31px;
      height: 70px;
      line-height: 70px;
      margin-top: -5px;
      background-image: url('~@/assets/leaf_y.svg');
      background-size: contain;
      background-repeat: no-repeat;
      @media #{$maxM}{
        font-size: 25px;
        height: 64px;
        line-height: 64px;
        margin-top: -3px;
      }
    }
    @media #{$IE}{
        svg:nth-child(2) {
            height: 14px;
        }
    }
  }
  .info {
    font-size: 18px;
    letter-spacing: 0.15em;
    margin-top: 40px;
    @media #{$maxM}{
      font-size: 16px;
      margin-top: 16px;
      letter-spacing: 0.05em;
    }
  }
  .btn {
    width: 270px !important;
    height: 52px !important;
    margin: 40px auto 0;
    @media #{$maxM}{
      margin: 16px auto 0;
    }
    .btn-inner {
      span {
        margin: 0 auto;
        font-size: 14px;
      }
    }
  }
}
</style>